/**
 * Admin 사이트 > 문의. 라우트 admin.php site.contacts 와 동기화.
 */
import { Logger } from "../../utils/Logger";
import { AdminIndexTable } from "../components/AdminIndexTable";
import { initChatComposer } from "../components/ChatComposer";

const CTRL_TAG = "AdminContactController";

export const AdminContactController = {
    index(): void {
        Logger.debug(`${CTRL_TAG}.index`);
        new AdminIndexTable({ pageSelector: ".admin-contacts" }).init();
    },
    show(): void {
        Logger.debug(`${CTRL_TAG}.show`);
        document
            .querySelectorAll<HTMLFormElement>('form[data-chat-composer="1"]')
            .forEach((form) => initChatComposer(form));
    },
};
